import Api from '@/api/Api';
import mixins from 'vuex-store/mixins';

const catalog = new Api({ name: 'MS_CATALOG_API_URL' });
const socoPublicApi = new Api({ name: 'MS_SOCO_PUBLIC_API_URL' });

// initial state
const state = () => ({});

const getters = {
  hasPopularCategory: (state) => Object.keys(state).length > 0,
};

const actions = {
  getPopularCategory: ({ rootState, commit }) => {
    const limit = rootState.screen.isDesktop ? 2 : 4;
    // fetch popular category
    return (
      catalog
        .getData({
          endpoint: '/categories',
          params: {
            filter: {
              is_popular: true,
            },
            fields: 'name slug link_rewrite my_soco_sql_id',
            limit: limit,
          },
        })

        // commit popular mutation
        .then(({ data: { data } }) => {
          commit('categories/setState', ['popular', data], { root: true });
        })

        // fetch all popular data
        .then(() => {
          const queue = [];

          rootState.categories.popular.forEach(({ link_rewrite }) => {
            queue.push(
              socoPublicApi.getData({
                endpoint: '/products/featured/popular-category',
                params: {
                  filter: {
                    'product_category.link_rewrite': link_rewrite,
                  },
                },
              })
            );
          });

          return Promise.all(queue);
        })

        // commit
        .then((res) => {
          rootState.categories.popular.forEach((arr, index) => {
            commit('setState', [index, res[index].data.data]);
            // commit('setState', [index, res[res.findIndex(data => data.data.data.parent_category.link_rewrite === arr.link_rewrite)].data.data])
          });
        })
    );
  },
};

const mutations = {
  ...mixins.mutations,
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
